import { render } from "./MessageInfoSheet.vue?vue&type=template&id=58ee3c6a&scoped=true"
import script from "./MessageInfoSheet.vue?vue&type=script&lang=js"
export * from "./MessageInfoSheet.vue?vue&type=script&lang=js"

import "./MessageInfoSheet.vue?vue&type=style&index=0&id=58ee3c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ee3c6a"]])

export default __exports__